import React from 'react';

interface RadioTabsProps {
  options: string[];
  selectedOption: string;
  onChange: (option: string) => void;
  className?: string;
}

const RadioTabs = ({
  options,
  selectedOption,
  onChange,
  className = ''
}: RadioTabsProps) => {
  return (
    <div className={`flex gap-2 ${className}`}>
      {options.map((option) => (
        <button
          key={option}
          onClick={() => onChange(option)}
          className={`px-4 py-2 text-sm transition-colors ${selectedOption === option
              ? 'bg-[#0E0C0C] text-white rounded-[3.3125rem]'
              : 'border border-[#D9D9D9] text-black rounded-[3.3125rem]'
            }`}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default RadioTabs; 